import axios from "axios";
import { BASE_URL } from "./api";

export const uploadFile = async (files, uploadUrl = "/upload") => {
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await axios.post(BASE_URL + uploadUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("File upload error:", error);
    throw error;
  }
};

export const getFiles = async (getFilesUrl) => {
  try {
    const response = await axios.get(getFilesUrl);
    return response.data; // Return the file data
  } catch (error) {
    console.error("Get files error:", error);
    throw error;
  }
};
